export const MessageToolbarTestIds = {
  buttonLastAddedEmoji: 'button_last_added_emoji',
  buttonMoreMenu: 'button_more_menu',
  buttonOpenDeleteDialog: 'button_open_deleteDialog',
  buttonOpenReportDialog: 'button_open_reportDialog',
  buttonPinMessage: 'button_pin_message',
  reportDialogContent: 'report_dialog_content',
  messageToReportText: 'messageToReport_text',
  reportReasonTextarea: 'report_reason_textarea',
  reportDialogActions: 'report_dialog_actions',
  cancelReportButton: 'cancel_report_button',
  confirmReportButton: 'confirm_report_button',
  buttonCancelDelete: 'button_cancel_delete',
  buttonConfirmDelete: 'button_confirm_delete',
  dialogDeleteContent: 'dialog_delete_content',
  dialogDeleteActions: 'dialog_delete_actions',
  deleteMenuItemTooltipTrigger: 'delete_menu_item_tooltip_trigger'
} as const;
